/**
 * What the top-of-composer selector currently has chosen. Drives both the send
 * mode and (for templates) the content load.
 *
 *   - `blank`      → empty email, full composer, "Send Email".
 *   - `template`   → email template's subject + body loaded into the composer.
 *   - `automation` → composer collapses to To + "Start Automation"; selecting
 *                    enrolls the contact in the automation (added in PR2).
 */
export type ComposerSelection =
	| { kind: 'blank' }
	| { kind: 'template'; id: string; name: string }
	| { kind: 'automation'; id: string; name: string };

/** Sentinel option value for the "Blank Template" entry. */
export const BLANK_OPTION_VALUE = 'blank';

/** Encode a selection as the Select's string value. */
export function selectionToValue(selection: ComposerSelection): string {
	switch (selection.kind) {
		case 'blank':
			return BLANK_OPTION_VALUE;
		case 'template':
			return `template:${selection.id}`;
		case 'automation':
			return `automation:${selection.id}`;
		default:
			return BLANK_OPTION_VALUE;
	}
}
